import IpadsIcon from '../../assets/img/pos-ipads.png';
import IpadImage from '../../assets/img/image-11-2@1x.png';
import IpadFrame from '../../assets/img/ipad-frame.png';
import PosIconSync1x from '../../assets/img/pos-icon-sync@1x.png';
import IpadVideo from '../../assets/videos/MBLM_Insights_V3.mp4';

import './index.css';
import './responsive.css';


const Card = (props) => {
  return (
    <div className="data-card">
      <div className="rectangle-293-4SqmWY"></div>

      { props.image && (
        <div className={'image-wrapper ' + props.icon}>
          <img className={'data-image ' + props.icon} src={props.image} />
        </div>
      ) }

      { props.video && (
        <div className={'image-wrapper ' + props.icon}>
          <div className='ipads-wrapper'>
            <div className='video-frame'>
              <img src={IpadFrame} />

              <video className='ipad-video' loop autoPlay muted>
                <source src={props.video} type="video/mp4" />
              </video>
            </div>

            <img src={IpadImage} />
          </div>
        </div>
      ) }

      <div className={'text-wrapper ' + props.icon}>
        <div className="icon-wrapper">
          <span className={"demopos-" + props.icon}></span>
        </div>


        <div className="data-title titles" dangerouslySetInnerHTML={{__html: props.title}}></div>
        <div className={'data-text bullets ' +  props.icon} dangerouslySetInnerHTML={{__html: props.text}}></div>
      </div>
    </div>
  );
}

function DataDeploySection() {
  return (
    <div className="data_deploy_block">
      <Card 
        image={PosIconSync1x} 
        icon={'deploy'} 
        title={'Single deployment'} 
        text={'Facilitate alignment between sales and marketing teams. Integrate and instantly access all content materials. Scale content across multiple devices, locations, and geographies.'}
      />

      <Card 
        video={IpadVideo}
        icon={'insights'} 
        title={'Real-time analytics <br />on content engagement'} 
        text={'Learn what content is accessed, presented, or shown in real time. Leverage metrics such as frequency, duration of views, and popular files shared with prospects.'}
      />
    </div>
  );
}

export default DataDeploySection;